import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ContentHaus from "@/pages/ContentHaus";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ContentHaus />} />
          <Route path="/contenthaus" element={<ContentHaus />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
